/**
 * API client for backend service
 */

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Create a new room
 */
export const createRoom = async (name = null, creatorName = null) => {
  const response = await api.post('/api/rooms', {
    name,
    empty_timeout: 300,
    max_participants: 0,
    creator_name: creatorName,
  });
  return response.data;
};

/**
 * Get room information
 */
export const getRoom = async (roomName) => {
  const response = await api.get(`/api/rooms/${roomName}`);
  return response.data;
};

/**
 * Delete a room
 */
export const deleteRoom = async (roomName) => {
  const response = await api.delete(`/api/rooms/${roomName}`);
  return response.data;
};

/**
 * Get access token for LiveKit
 */
export const getToken = async (roomName, participantName) => {
  const response = await api.post('/api/tokens', {
    room_name: roomName,
    participant_name: participantName,
    can_publish: true,
    can_subscribe: true,
    can_publish_data: true,
  });
  return response.data;
};

/**
 * Mute participant
 */
export const muteParticipant = async (roomName, participantIdentity, muteAudio = null, muteVideo = null) => {
  const response = await api.post(`/api/participants/${roomName}/mute`, {
    participant_identity: participantIdentity,
    mute_audio: muteAudio,
    mute_video: muteVideo,
  });
  return response.data;
};

/**
 * Kick participant
 */
export const kickParticipant = async (roomName, participantIdentity, reason = null) => {
  const response = await api.post(`/api/participants/${roomName}/kick`, {
    participant_identity: participantIdentity,
    reason,
  });
  return response.data;
};

/**
 * Send chat message
 */
export const sendChatMessage = async (roomName, participantName, message) => {
  const response = await api.post('/api/chat/send', {
    room_name: roomName,
    participant: participantName,
    message,
  });
  return response.data;
};

/**
 * Get chat history
 */
export const getChatHistory = async (roomName) => {
  const response = await api.get(`/api/chat/${roomName}`);
  return response.data;
};

/**
 * Create invite link for a room
 * Returns a URL that pre-fills the room code on the main page
 */
export const createInviteLink = async (roomName) => {
  const response = await api.post('/api/invites/create', {
    room_name: roomName,
  });
  return response.data;
};

export default api;

